<template>
<section class="section about">
    <div class="container">
        <div :class="['columns is-variable is-8', {'is-mobile': !is_mobile}]">
            <div class="column is-5">
                <div class="about__portrait-holder" v-if="section_data.portrait">
                    <figure class="about__portrait">
                        <img class="is-block" :alt="section_data.portrait.title" :src="section_data.portrait.url" />
                    </figure>
                </div>
            </div>
            <div class="column is-7 about__content">
                <h2 class="title is-3">{{section_data.title}}</h2>
                <p class="subtitle is-6">{{section_data.subtitle}}</p>
                <div class="content" v-html="section_data.content"></div>
                <div class="columns about__skills is-variable is-1 is-multiline is-mobile">
                    <div class="column about__skill is-2" v-for="skill in section_data.skills" :title="skill.title">
                        <img :src="skill.logo.url" />
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
</template>

<script>
import PosHandler from '../../mixins/PosHandler';
export default {
    name    :   'SectionAbout',
    mixins  :   [ PosHandler ],
    props   :   ['section_data', 'is_mobile']
}
</script>



// WEBPACK FOOTER //
// src/components/blocks/sections/SectionAbout.vue